import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const TriangleIndicatorIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 18 15"
         fill="none"
         {...props}
      >
         <g filter="url(#filter0_d_10699_108562)">
            <path
               d="M9.86824 12.4806C9.48435 13.1524 8.51565 13.1524 8.13176 12.4806L1.85494 1.49614C1.47399 0.829481 1.95536 -3.6157e-07 2.72318 -2.94445e-07L15.2768 8.03029e-07C16.0446 8.70154e-07 16.526 0.829483 16.1451 1.49614L9.86824 12.4806Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <filter
               id="filter0_d_10699_108562"
               x="0.722656"
               y="0"
               width="16.5547"
               height="14.9844"
               filterUnits="userSpaceOnUse"
               colorInterpolationFilters="sRGB"
            >
               <feFlood
                  floodOpacity="0"
                  result="BackgroundImageFix"
               />
               <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
               />
               <feOffset dy="1" />
               <feGaussianBlur stdDeviation="0.5" />
               <feComposite
                  in2="hardAlpha"
                  operator="out"
               />
               <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
               />
               <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_10699_108562"
               />
               <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_10699_108562"
                  result="shape"
               />
            </filter>
         </defs>
      </svg>
   )
}

export default TriangleIndicatorIcon
